// extracted by mini-css-extract-plugin
export default {"container":"br-z","brandName":"cr-z","productName":"dr-z","productNamePdpEnhancements":"er-z","breakLongProductName":"fr-z"};